export default __webpack_public_path__ + "static/media/supper_apps_xl2.28292878.png";